const EXTENSION_TO_MIME = {
    pdf: 'application/pdf',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    webp: 'image/webp',
    bmp: 'image/bmp',
}

const IMAGE_EXTENSIONS = new Set(['png', 'jpg', 'jpeg', 'webp', 'bmp'])

// Extensions that the backend converts to PDF before serving.
const PDF_CONVERTED_EXTENSIONS = new Set(['docx'])

const getExtension = (name = '') => {
    const parts = name.split('.')
    return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : ''
}

/**
 * Returns 'image' | 'pdf' | 'other' based on filename extension.
 * docx is included as 'pdf' because the backend converts it on import.
 * SVG and HTML are intentionally excluded — blob object URLs inherit the app
 * origin and SVG/HTML can carry executable scripts, so those stay download-only.
 * Use as a fallback when the Content-Type header is unavailable.
 */
export const getAttachmentKind = (name) => {
    const ext = getExtension(name)
    if (ext === 'pdf' || PDF_CONVERTED_EXTENSIONS.has(ext)) return 'pdf'
    if (IMAGE_EXTENSIONS.has(ext)) return 'image'
    return 'other'
}

/**
 * Derives 'image' | 'pdf' | 'other' | null from a Content-Type header value.
 * Returns null when the type is absent or generic (application/octet-stream),
 * signalling callers to fall back to getAttachmentKind(name).
 * SVG is excluded for the same XSS reason as in getAttachmentKind.
 */
export const getKindFromMimeType = (contentType) => {
    if (!contentType) return null
    const type = contentType.split(';')[0].trim().toLowerCase()
    if (type === 'application/pdf') return 'pdf'
    if (type.startsWith('image/') && type !== 'image/svg+xml') return 'image'
    if (type === 'application/octet-stream') return null // unknown — let filename extension decide
    return 'other'
}

/**
 * Returns a MIME type string for a given filename, used as a fallback when
 * the Content-Type response header is absent or generic (application/octet-stream).
 */
export const getMimeType = (name) => {
    const ext = getExtension(name)
    return EXTENSION_TO_MIME[ext] || 'application/octet-stream'
}
